/* EIGHTY5 theme behavior: menu, reveals, thumb bar, AJAX cart drawer. Zero dependencies. */
(() => {
  const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];

  /* reveals */
  /* Reveals. IntersectionObserver never fires in some embedded/in-app browsers,
     which would leave every [data-r] element invisible forever. Belt and braces:
     anything still hidden 1.5s after load is shown regardless. */
  const revealAll = () => $$('[data-r]:not(.in)').forEach(el => el.classList.add('in'));
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    }), { threshold: .12, rootMargin: '0px 0px -6%' });
    $$('[data-r]').forEach(el => io.observe(el));
    setTimeout(revealAll, 1500);
  } else revealAll();

  /* menu */
  const menu = $('#menu');
  $('#menuT')?.addEventListener('click', () => menu.classList.add('on'));
  $('#menuX')?.addEventListener('click', () => menu.classList.remove('on'));

  /* thumb bar after hero (suppressed on PDP, which has its own bar) */
  const thumb = $('#thumb'), hero = $('.hero'), pdpBar = $('[data-pdpbar]');
  if (pdpBar) thumb?.remove();
  else if (thumb && hero) new IntersectionObserver(([e]) =>
    thumb.classList.toggle('on', !e.isIntersecting && !$('#drawer').classList.contains('on'))
  ).observe(hero);
  else if (thumb) thumb.classList.add('on');

  /* Background video hydration lives inline in snippets/bg-video-init.liquid
     so it can never fall out of sync with a cached copy of this file. */

  /* ---- AJAX cart ---- */
  const money = cents => '$' + (cents / 100).toFixed(2);
  const openDr = () => { $('#menu')?.classList.remove('on'); $('#drawer').classList.add('on'); $('#scrim').classList.add('on'); thumb?.classList.remove('on'); };
  const closeDr = () => { $('#drawer').classList.remove('on'); $('#scrim').classList.remove('on'); };

  /* Threshold is authored on the cart section so Liquid and JS can't drift.
     Falls back to 8500 on pages that don't render the cart section. */
  const shipTarget = () => +($('[data-free-ship]')?.dataset.freeShip || 8500);

  const shipCopy = (total, target) => {
    const left = Math.max(0, target - total);
    return left > 0
      ? `You're <b>${money(left)}</b> from free shipping.`
      : `<b>Free shipping unlocked.</b> Obviously — it's ${Math.round(target / 100)}.`;
  };

  /* One tap to free shipping: the cheapest real variant that closes the gap.
     Only when the gap is small enough that the suggestion is a favour, not a push. */
  let catalog = null;
  async function upsell(cart, target) {
    const box = $('#drUp'); if (!box) return;
    const gap = target - cart.total_price;
    if (!cart.item_count || gap <= 0 || gap > 4000) { box.hidden = true; return; }
    try {
      catalog = catalog || (await fetch('/products.json?limit=50').then(r => r.json())).products;
    } catch (e) { box.hidden = true; return; }
    const inCart = new Set(cart.items.map(i => i.variant_id));
    let best = null;
    for (const p of catalog) for (const v of p.variants) {
      const price = Math.round(parseFloat(v.price) * 100);
      if (!v.available || inCart.has(v.id) || price < gap) continue;
      if (!best || price < best.price) best = { id: v.id, price, title: p.title, vt: v.title };
    }
    if (!best) { box.hidden = true; return; }
    box.innerHTML = `<span>Add <b>${best.title}</b>${best.vt && best.vt !== 'Default Title' ? ' · ' + best.vt : ''} and shipping's on us.</span>
      <button class="b b--sm b--hot" type="button" data-add-variant="${best.id}">+ ${money(best.price)}</button>`;
    box.hidden = false;
  }

  async function refreshCart() {
    const cart = await fetch('/cart.js').then(r => r.json());
    const target = shipTarget();
    const pct = Math.min(100, cart.total_price / target * 100) + '%';
    $$('.cartN').forEach(el => el.textContent = cart.item_count);

    /* drawer */
    if ($('#drTotal')) $('#drTotal').textContent = money(cart.total_price);
    if ($('#shipMsg')) $('#shipMsg').innerHTML = shipCopy(cart.total_price, target);
    if ($('#shipBar')) $('#shipBar').style.width = pct;
    const bar = $('#shipBar');
    if (bar) {
      const done = cart.total_price >= target && cart.item_count > 0;
      if (done && !bar.classList.contains('lit') && refreshCart.primed) {
        bar.classList.add('ignite'); setTimeout(() => bar.classList.remove('ignite'), 1200);
      }
      bar.classList.toggle('lit', done);
    }
    refreshCart.primed = true;
    upsell(cart, target);
    if ($('#drItems')) $('#drItems').innerHTML = cart.items.length ? cart.items.map((it, i) => `
      <div class="dr__it"><div class="dr__im">${it.image ? `<img src="${it.image}&width=104" alt="">` : ''}</div>
        <div class="dr__n"><b>${it.product_title}</b><span>${it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title + ' · ' : ''}${money(it.price)}</span><br>
          <span class="qty"><button data-line="${i + 1}:${it.quantity - 1}">−</button><span>${it.quantity}</span><button data-line="${i + 1}:${it.quantity + 1}">+</button></span></div>
        <div style="font-weight:800;font-size:.85rem">${money(it.final_line_price)}</div></div>`).join('')
      : '<p class="dr__mt">Nothing but air in here. Fix that.</p>';

    /* cart page, when we're on it */
    const cpItems = $('#cpItems');
    if (cpItems) {
      if (!cart.items.length) { location.reload(); return; }
      if ($('#cpTotal')) $('#cpTotal').textContent = money(cart.total_price);
      if ($('#cpShipMsg')) $('#cpShipMsg').innerHTML = shipCopy(cart.total_price, target);
      if ($('#cpShipBar')) $('#cpShipBar').style.width = pct;
      cpItems.innerHTML = cart.items.map((it, i) => `
      <div class="cp__it">
        <a class="cp__im" href="${it.url}">${it.image ? `<img src="${it.image}&width=160" alt="" loading="lazy">` : ''}</a>
        <div class="cp__n">
          <a href="${it.url}"><b>${it.product_title}</b></a>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<span>${it.variant_title}</span>` : ''}
          <span>${money(it.price)} each</span>
          <span class="qty">
            <button type="button" data-line="${i + 1}:${it.quantity - 1}" aria-label="Decrease quantity">−</button>
            <span>${it.quantity}</span>
            <button type="button" data-line="${i + 1}:${it.quantity + 1}" aria-label="Increase quantity">+</button>
          </span>
        </div>
        <div class="cp__p">
          <b>${money(it.final_line_price)}</b>
          <button class="cp__rm" type="button" data-line="${i + 1}:0">Remove</button>
        </div>
      </div>`).join('');
    }
  }

  /* the product's photo flies into the cart */
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function flyToCart(btn) {
    if (calm) return;
    const src = btn.closest('.tile')?.querySelector('.ph img') || $('[data-pdp-main]') || btn.closest('.bs')?.querySelector('.bs__img img');
    const dest = [...$$('.jsCart')].find(el => el.offsetParent) || $('.jsCart');
    if (!src || !dest) return;
    const a = src.getBoundingClientRect(), b = dest.getBoundingClientRect();
    if (!a.width) return;
    const img = src.cloneNode(); img.removeAttribute('srcset');
    Object.assign(img.style, { position: 'fixed', left: a.left + 'px', top: a.top + 'px', width: a.width + 'px', height: a.height + 'px',
      objectFit: 'contain', zIndex: 2000, pointerEvents: 'none', borderRadius: '12px' });
    document.body.appendChild(img);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    img.animate([{ transform: 'none', opacity: 1 }, { transform: `translate(${dx}px,${dy}px) scale(.08)`, opacity: .35 }],
      { duration: 650, easing: 'cubic-bezier(.5,0,.2,1)' }).onfinish = () => img.remove();
  }

  const pdpQty = () => Math.max(1, +($('[data-pdp-qty-value]')?.textContent || 1));

  document.addEventListener('click', async e => {
    const add = e.target.closest('[data-add-variant]');
    if (add) {
      e.preventDefault();
      const orig = add.innerHTML;
      const quantity = add.hasAttribute('data-pdp-atc') ? pdpQty() : 1;
      try {
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: +add.dataset.addVariant, quantity }) });
        flyToCart(add);
        navigator.vibrate?.(12);
        add.classList.add('is-added'); add.innerHTML = '✓ In. Obviously.';
        $$('.cartN').forEach(el => { el.classList.add('bump'); setTimeout(() => el.classList.remove('bump'), 350); });
        await refreshCart();
        setTimeout(() => { add.classList.remove('is-added'); add.innerHTML = orig; }, 1400);
        setTimeout(openDr, 400);
      } catch (err) { add.innerHTML = orig; }
      return;
    }
    const q = e.target.closest('[data-line]');
    if (q) {
      const [line, quantity] = q.dataset.line.split(':').map(Number);
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: Math.max(0, quantity) }) });
      refreshCart();
    }
  });
  $$('.jsCart').forEach(el => el.addEventListener('click', () => { refreshCart(); openDr(); }));
  $('#drX')?.addEventListener('click', closeDr);
  $('#scrim')?.addEventListener('click', closeDr);
  addEventListener('keydown', e => { if (e.key === 'Escape') { closeDr(); menu?.classList.remove('on'); } });
  refreshCart();

  /* ---- PDP: variant cards, qty, buy now, gallery, sticky bar ---- */
  const moneyTrim = cents => (cents % 100 === 0) ? '$' + (cents / 100) : money(cents);

  /* tile quick-pick: expand pack ladder in place */
  document.addEventListener('click', e => {
    const qp = e.target.closest('[data-qp-toggle]');
    if (!qp) return;
    const panel = qp.closest('.tile')?.querySelector('.tile__qp');
    if (!panel) return;
    const wasOpen = !panel.hidden;
    $$('.tile__qp').forEach(p => {
      if (p !== panel && !p.hidden) {
        p.hidden = true;
        const t = p.closest('.tile').querySelector('[data-qp-toggle]');
        if (t?.dataset.orig) t.innerHTML = t.dataset.orig;
      }
    });
    if (!qp.dataset.orig) qp.dataset.orig = qp.innerHTML;
    panel.hidden = wasOpen;
    qp.innerHTML = wasOpen ? qp.dataset.orig : '✕ Close';
    qp.setAttribute('aria-expanded', !wasOpen);
  });

  document.addEventListener('click', e => {
    const card = e.target.closest('[data-vcard]');
    if (card) {
      $$('[data-vcard]').forEach(c => { c.classList.toggle('on', c === card); c.setAttribute('aria-checked', c === card); });
      const { vid, vprice, vunits, vtitle } = card.dataset;
      /* sold-out variant: swap the buy row for the restock form, point it at this variant */
      const oos = card.dataset.vavailable !== 'true';
      const buyRow = $('[data-pdp-buyrow]'), buyNow = $('[data-buy-now]'), oosBox = $('.pdp__oos'), bis = $('form.restock[data-bis-variant]');
      if (buyRow) buyRow.hidden = oos;
      if (buyNow) buyNow.hidden = oos;
      if (oosBox) oosBox.hidden = !oos;
      if (bis) bis.dataset.bisVariant = vid;
      if (pdpBar) pdpBar.classList.toggle('is-oos', oos);
      $$('[data-pdp-price]').forEach(el => countTo(el, +vprice));
      drawPack(+vunits, card.dataset.vtitle);
      const per = $('[data-pdp-per]');
      if (per) per.textContent = +vunits > 1 ? `${money(Math.round(vprice / vunits))} per cigar · ${vtitle}` : vtitle;
      const barT = $('[data-pdp-bar-title]'); if (barT) barT.textContent = vtitle;
      $$('[data-pdp-atc]').forEach(b => b.dataset.addVariant = vid);
      const bn = $('[data-buy-now]'); if (bn) bn.dataset.buyNow = vid;
      return;
    }
    const qbtn = e.target.closest('[data-pdp-qty]');
    if (qbtn) {
      const out = $('[data-pdp-qty-value]');
      out.textContent = Math.max(1, +out.textContent + +qbtn.dataset.pdpQty);
      return;
    }
    const bn = e.target.closest('[data-buy-now]');
    if (bn) { location.href = `/cart/${bn.dataset.buyNow}:${pdpQty()}`; return; }
    const th = e.target.closest('[data-thumb]');
    if (th) {
      const main = $('[data-pdp-main]');
      if (main) { main.style.opacity = 0; main.src = th.dataset.thumb; main.srcset = ''; main.onload = () => main.style.opacity = 1; }
      $$('[data-thumb]').forEach(t => t.classList.toggle('on', t === th));
    }
  });

  /* price counts to the new pack instead of snapping */
  function countTo(el, cents) {
    const from = Math.round(parseFloat((el.textContent || '0').replace(/[^0-9.]/g, '')) * 100) || cents;
    if (calm || from === cents) { el.textContent = moneyTrim(cents); return; }
    const t0 = performance.now(), dur = 420;
    const step = t => { const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el.textContent = moneyTrim(Math.round((from + (cents - from) * e) / (k < 1 ? 1 : 1)));
      if (k < 1) requestAnimationFrame(step); else el.textContent = moneyTrim(cents); };
    requestAnimationFrame(step);
  }
  /* a row of cigars that draws the pack you picked */
  function drawPack(units, title) {
    const row = $('[data-pcount]'); if (!row) return;
    const n = Math.max(1, Math.min(20, units || 1));
    row.innerHTML = Array.from({ length: n }, (_, i) => `<i style="--i:${i}"></i>`).join('') +
      (n > 1 ? `<span>${n} cigars</span>` : '');
    row.classList.toggle('box', /box/i.test(title || ''));
  }

  /* init per-cigar line + show sticky bar once buy box scrolls away */
  const initCard = $('[data-vcard].on');
  if (initCard) {
    const { vprice, vunits, vtitle } = initCard.dataset;
    const per = $('[data-pdp-per]');
    if (per) per.textContent = +vunits > 1 ? `${money(Math.round(vprice / vunits))} per cigar · ${vtitle}` : vtitle;
    drawPack(+vunits, vtitle);
  }
  if (pdpBar) {
    const buyBox = $('.pdp__buy');
    if (buyBox) new IntersectionObserver(([e]) =>
      pdpBar.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0)
    ).observe(buyBox);
  }

  /* countdown (drop teaser) */
  const cd = $('[data-drop-date]');
  if (cd) {
    const t0 = new Date(cd.dataset.dropDate).getTime();
    const pad = n => String(Math.max(0, n)).padStart(2, '0');
    const tick = () => { const t = t0 - Date.now();
      cd.querySelector('.cdD').textContent = pad(t / 864e5 | 0);
      cd.querySelector('.cdH').textContent = pad(t / 36e5 % 24 | 0);
      cd.querySelector('.cdM').textContent = pad(t / 6e4 % 60 | 0);
      cd.querySelector('.cdS').textContent = pad(t / 1e3 % 60 | 0); };
    tick(); setInterval(tick, 1000);
  }

  /* How long you got? Filter the lineup by smoke time. The sampler covers
     every length, so it always stays. */
  $$('[data-tfilt]').forEach(f => {
    const sec = f.closest('section'), tiles = [...sec.querySelectorAll('.tile[data-min]')];
    const bucket = m => m === 'any' ? 'any' : (+m <= 50 ? '45' : +m <= 75 ? '60' : '90');
    f.addEventListener('click', e => {
      const chip = e.target.closest('[data-t]'); if (!chip) return;
      const t = chip.dataset.t;
      const apply = () => {
        f.querySelectorAll('[data-t]').forEach(c => { c.classList.toggle('on', c === chip); c.setAttribute('aria-pressed', c === chip); });
        tiles.forEach(el => { const b = bucket(el.dataset.min); el.hidden = !(t === 'all' || b === 'any' || b === t); });
        sec.querySelector('.row')?.scrollTo({ left: 0, behavior: 'smooth' });
      };
      if (document.startViewTransition && !calm) document.startViewTransition(apply); else apply();
      navigator.vibrate?.(6);
    });
  });

  /* the burn line: a thin ember that tracks how far down the page you are */
  const burn = $('#burn');
  if (burn) {
    let ticking = false;
    const set = () => { const h = document.documentElement.scrollHeight - innerHeight;
      burn.style.setProperty('--p', h > 0 ? Math.min(1, scrollY / h) : 0); ticking = false; };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(set); } }, { passive: true });
    set();
  }

  /* tasting notes land one word at a time when the blend scrolls in */
  const bss = $$('[data-bs]');
  if (bss.length) {
    if ('IntersectionObserver' in window) {
      let fired = false;
      const o = new IntersectionObserver(es => { fired = true; es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('seen'); o.unobserve(e.target); } }); }, { threshold: .3 });
      bss.forEach(el => o.observe(el));
      /* some in-app browsers never fire the observer; never leave notes invisible */
      setTimeout(() => { if (!fired) bss.forEach(el => el.classList.add('seen')); }, 2500);
    } else bss.forEach(el => el.classList.add('seen'));
  }

  /* faq accordion */
  $$('.faq__q').forEach(q => q.addEventListener('click', () => {
    const it = q.parentElement, a = it.querySelector('.faq__a'), open = it.classList.contains('open');
    $$('.faq__it.open').forEach(o => { o.classList.remove('open'); o.querySelector('.faq__a').style.maxHeight = 0; });
    if (!open) { it.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
  }));
})();
